import { Alert, Platform } from "react-native";
import { PERMISSIONS, RESULTS, check, openSettings, request } from "react-native-permissions";

class permissionServices {
    //Permission to access a gallery or file.
    storegeAccessPermission() {
        const promise = new Promise((resolve, reject) => {
            const androidVersion: any = Platform.constants
            check(Platform.OS == 'ios' ? PERMISSIONS.IOS.MEDIA_LIBRARY : androidVersion?.Release > 12 ? PERMISSIONS.ANDROID.READ_MEDIA_IMAGES : PERMISSIONS.ANDROID.READ_EXTERNAL_STORAGE)
                .then((result) => {
                    switch (result) {
                        case RESULTS.UNAVAILABLE:
                            request(
                                Platform.OS === "ios"
                                    ? PERMISSIONS.IOS.PHOTO_LIBRARY
                                    : androidVersion?.Release > 12
                                        ? PERMISSIONS.ANDROID.READ_MEDIA_IMAGES
                                        : PERMISSIONS.ANDROID.READ_EXTERNAL_STORAGE,
                            ).then(result => {
                                if (result === "blocked") {
                                    reject(false);
                                } else {
                                    resolve(true);
                                }
                            });
                            break;

                        case RESULTS.DENIED:
                            request(
                                Platform.OS === "ios"
                                    ? PERMISSIONS.IOS.PHOTO_LIBRARY
                                    : androidVersion?.Release > 12
                                        ? PERMISSIONS.ANDROID.READ_MEDIA_IMAGES
                                        : PERMISSIONS.ANDROID.READ_EXTERNAL_STORAGE,
                            ).then(result => {
                                if (
                                    (result === "blocked" && Platform.OS === "ios") ||
                                    (result === "denied" && Platform.OS === "android")
                                ) {
                                    reject(false);
                                }
                                else if (result === "blocked" && Platform.OS === "android") {
                                    Alert.alert("Permission Denied", `You must allow "ZenBasket POS" for using gallery`, [
                                        {
                                            text: "Cancel",
                                            onPress: () => {
                                                reject(false);
                                            },
                                            style: "cancel",
                                        },
                                        {
                                            text: "Go to Settings",
                                            onPress: () => {
                                                openSettings().catch(() => console.warn("cannot open settings"));
                                            },
                                        },
                                    ]);
                                } else {
                                    resolve(true);
                                }
                            });
                            break;
                        case RESULTS.LIMITED:
                            console.log("The permission is Limited");
                            break;
                        case RESULTS.GRANTED:
                            console.log("The permission is GRANTED");
                            resolve(true);
                            break;
                        case RESULTS.BLOCKED:
                            Alert.alert("Permission Denied", `You must allow "ZenBasket POS" for using gallery`, [
                                {
                                    text: "Cancel",
                                    onPress: () => {
                                        reject(false);
                                    },
                                    style: "cancel",
                                },
                                {
                                    text: "Go to Settings",
                                    onPress: () => {
                                        openSettings().catch(() => console.warn("cannot open settings"));
                                    },
                                },
                            ]);
                            break;
                    }

                })
                .catch((err: any) => {
                    reject(false)
                })


        })
        return promise
    }
    //Permission to access a camera
    cameraAccessPermission() {
        const promise = new Promise((resolve, reject) => {
            check(Platform?.OS == "ios" ? PERMISSIONS?.IOS?.CAMERA : PERMISSIONS?.ANDROID?.CAMERA)
                .then((result) => {
                    switch (result) {
                        case RESULTS.UNAVAILABLE:
                            request(Platform?.OS == "ios" ? PERMISSIONS?.IOS?.CAMERA : PERMISSIONS?.ANDROID?.CAMERA).then(result => {
                                if (result === "blocked") {
                                    reject(false);
                                } else {
                                    resolve(true);
                                }
                            });
                            break;

                        case RESULTS.DENIED:
                            request(Platform?.OS == "ios" ? PERMISSIONS?.IOS?.CAMERA : PERMISSIONS?.ANDROID?.CAMERA).then(result => {
                                if (
                                    (result === "blocked" && Platform.OS === "ios") ||
                                    (result === "denied" && Platform.OS === "android")
                                ) {
                                    reject(false);
                                }
                                else if (result === "blocked" && Platform.OS === "android") {
                                    Alert.alert("Permission Denied", `You must allow "ZenBasket POS" for using camera`, [
                                        {
                                            text: "Cancel",
                                            onPress: () => {
                                                reject(false);
                                            },
                                            style: "cancel",
                                        },
                                        {
                                            text: "Go to Settings",
                                            onPress: () => {
                                                openSettings().catch(() => console.warn("cannot open settings"));
                                            },
                                        },
                                    ]);
                                } else {
                                    resolve(true);
                                }
                            });
                            break;
                        case RESULTS.LIMITED:
                            console.log("The permission is Limited");
                            break;
                        case RESULTS.GRANTED:
                            console.log("The permission is GRANTED");
                            resolve(true);
                            break;
                        case RESULTS.BLOCKED:
                            Alert.alert("Permission Denied", `You must allow "ZenBasket POS" for using camera`, [
                                {
                                    text: "Cancel",
                                    onPress: () => {
                                        reject(false);
                                    },
                                    style: "cancel",
                                },
                                {
                                    text: "Go to Settings",
                                    onPress: () => {
                                        openSettings().catch(() => console.warn("cannot open settings"));
                                    },
                                },
                            ]);
                            break;
                    }

                })
                .catch((err: any) => {
                    reject(false)
                })


        })
        return promise
    }
}

const PermissionServices = new permissionServices()
export default PermissionServices